import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useErrorHandler } from "react-error-boundary";

import {
  landerCplQuizAtom,
  landerCplQuizGrantedEntriesAtom,
} from "../../../lander-cpl-quiz/lander-cpl-quiz.state";
import { updateFormioSubmission } from "../../../shared/api/yenta-api";
import { LanderQuizButton } from "../../../shared/components/lander-quiz-components/lander-quiz-button/lander-quiz-button.component";
import { isQuestionCorrect, setQuestionAnswer } from "../../utils";
import {
  initVideoAdQuestion,
  videoAdFinishedAtom,
  videoAdsGrantedEntriesCounterAtom,
  videoAdsQuestionCounterAtom,
  videoAdsQuizCurrentQuestionAtom,
  videoAdsQuizQuestionsAtom,
} from "../../video-ads-quiz.state";
import { VideoAdsQuizQuestion } from "../../video-ads-quiz.types";
import { useVideoAdsState } from "../../video-ads-service.state";

export const VideoAdsQuizBody: React.FC = () => {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const [videoAdsQuiz, setVideoAdsQuiz] = useAtom(videoAdsQuizQuestionsAtom);
  const [questionCounter] = useAtom(videoAdsQuestionCounterAtom);
  const [entriesCounter] = useAtom(videoAdsGrantedEntriesCounterAtom);
  const [currentQuestion, setCurrentQuestion] = useAtom(
    videoAdsQuizCurrentQuestionAtom
  );
  const [, setVideoAdFinished] = useAtom(videoAdFinishedAtom);

  const [buttonDisabledOnAnswered, setButtonDisabledOnAnswered] = useState(
    false
  );
  const handleWidgetError = useErrorHandler();
  const { defineVideoAdSlot, videoUnitAdPath } = useVideoAdsState();
  const [landerCplQuizGrantedEntries] = useAtom(
    landerCplQuizGrantedEntriesAtom
  );

  const optionClick = (selectedId: string) => {
    const questionAnswered: VideoAdsQuizQuestion = setQuestionAnswer(
      currentQuestion,
      selectedId
    );
    setCurrentQuestion(questionAnswered);
    setVideoAdsQuiz([...videoAdsQuiz, questionAnswered]);
    setButtonDisabledOnAnswered(true);

    if (isQuestionCorrect(questionAnswered) && videoUnitAdPath !== "-") {
      defineVideoAdSlot();
    }
  };

  useEffect(() => {
    setButtonDisabledOnAnswered(false);
    setCurrentQuestion({
      id: `question-0`,
      options: initVideoAdQuestion,
      answer: false,
    });
    setVideoAdFinished(false);
  }, [questionCounter, setCurrentQuestion, setVideoAdFinished]);

  useEffect(() => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    if (!submission) {
      return;
    }

    const sweepFormUrl =
      document
        .querySelector("#FormSweepstake")
        ?.getAttribute("data-form-path-url") ?? "";

    const patchData = {
      ...submission.data,
      quizExtraEntries:
        entriesCounter +
        (landerCplQuiz.prevExtraEntries ?? 0) +
        (landerCplQuizGrantedEntries ?? 0),
    };

    updateFormioSubmission(
      sweepFormUrl,
      {
        ...submission,
        data: patchData,
      },
      handleWidgetError
    ).then((submission) => {
      window.theme.Sweepstake.prototype.storeSubmission(submission);
      window.theme.Sweepstake.prototype.storeSubmissionHash(submission);
    });
  }, [
    entriesCounter,
    handleWidgetError,
    landerCplQuiz.prevExtraEntries,
    landerCplQuizGrantedEntries,
  ]);

  return (
    <div key={currentQuestion.id} className="video__ads__quiz__body">
      <div className="video__ads__quiz__body--question-container">
        <div
          className="video__ads__quiz__body--question-title"
          data-testid="video__ads__quiz-title"
        >
          {`Would you like to watch ${
            questionCounter + 1 === 1 ? "a" : "another"
          } short ad to earn +1 extra entry at the end of the video?. (Earn +1 entry per video watched. Video ${
            questionCounter + 1
          } of ${landerCplQuiz.number_of_cosponsors})`}
        </div>
        <div className="video__ads__quiz__body--question-actions">
          {currentQuestion.options.map((option) => {
            return (
              <div
                key={`option-${option.id}`}
                className="video__ads__quiz__body--button-container"
              >
                <LanderQuizButton
                  key={option.id}
                  data-testid={option.id}
                  isSelected={option.isSelected}
                  isCorrect={option.isCorrect}
                  disabled={buttonDisabledOnAnswered}
                  onClickOption={() => optionClick(option.id)}
                >
                  {option.textOption}
                </LanderQuizButton>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
